var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"film_wrapper"},[_c('film-header',{staticClass:"app_header"}),_c('el-scrollbar',{ref:"filmMain",staticClass:"film_main"},[_c('film-main'),_c('ys-nameplate'),_c('ys-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }